import { useTranslation } from "next-i18next";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fade from "@mui/material/Fade";
import BreadcrumbsComponent from "@atoms/Breadcrumbs/Breadcrumbs";
import { Section } from "@atoms/Section";
import FAQ from "@containers/FAQ";
import SearchBox from "@ds/components/SearchBox";
import Text from "@ds/components/Text";
import useActions from "../../hooks/useActions";
import type { IPropsGetSupport } from "../../interface";
import useStyles from "../../styles";
import Header from "@layouts/Main/lib/Header";

const Desktop: React.FC<IPropsGetSupport> = ({ isMobile, dataFaq, topic }) => {
  const { search, handleSearch, fade, breadcrumbs, dataVariants } = useActions(topic);
  const classes = useStyles({ search, isMobile });
  const { t } = useTranslation(["common", "faq"]);

  const renderSearchBox = (
    <SearchBox
      onChange={handleSearch}
      value={search}
      placeholder={t("faq:placeholder")}
      css={{
        backgroundColor: "#FFF",
        border: "1px solid #DEE3ED",
        height: "48px",
      }}
    />
  );

  const renderComponentBanner = (
    <Box className={classes.bannerBody} gap={3}>
      <Text
        variant="h1"
        weight="700"
        color={search ? "general-main" : "white"}
        sx={{ fontSize: "40px" }}
      >
        {t("faq:title")}
      </Text>
      <Text variant="body1" color={search ? "general-main" : "white"} weight="600">
        {t("faq:subtitle")}
      </Text>
      <Box className={classes.variantSection} width="100%" maxWidth="md">
        <Fade in={fade}>
          <Box display={search ? "none" : "contents"}>
            {dataVariants.map(
              (el: { title: string; subTitle: string; icon: string }, idx: number) => (
                <Box key={idx} className={classes.variantContent}>
                  <Box component="img" src={el.icon} alt="icon-img" width="44px" height="44px" />
                  <Box className={classes.variantText}>
                    <Text variant="subtitle1" weight="600" color="white" sx={{ fontSize: 18 }}>
                      {el.title}
                    </Text>
                    <Text variant="subtitle2" weight="600" color="white" sx={{ fontSize: 14 }}>
                      {el.subTitle}
                    </Text>
                  </Box>
                </Box>
              ),
            )}
          </Box>
        </Fade>
        <Box mt={search ? 0 : "32px"} width="100%">
          {renderSearchBox}
        </Box>
      </Box>
    </Box>
  );

  return (
    <>
      <Header
        setExpand={function (): void {
          throw new Error("Function not implemented.");
        }}
      />
      <Box position="relative" mt="70px">
        {topic && (
          <Section variant="gray" maxWidth="full-width" paddingY={1}>
            <Container maxWidth="lg" disableGutters>
              <BreadcrumbsComponent
                homeUrl={{ label: t("common:root"), productPath: "/bantuan" }}
                breadcrumbs={breadcrumbs}
              />
            </Container>
          </Section>
        )}
        <Section pt={5} className={classes.sectionHeader}>
          {renderComponentBanner}
        </Section>
        <Section pt={5}>
          <FAQ dataFaq={dataFaq} isGetSupport={true} />
        </Section>
      </Box>
    </>
  );
};

export default Desktop;
